<template>
  <ankh-list :showBtnGroup="false">
    <template #search-form>
      <el-form-item :label="$t('名称')">
        <el-input :placeholder="$t('名称')" v-model="searchForm.name" clearable/>
      </el-form-item>
      <el-form-item :label="$t('创建者编号')">
        <el-input :placeholder="$t('创建者编号')" v-model="searchForm.userNum" clearable/>
      </el-form-item>

      <el-form-item :label="$t('创建者名称')">
        <el-input :placeholder="$t('创建者名称')" v-model="searchForm.nickname" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template #table="{height}">
      <table-list
          :height="height"
          ref="list"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData">
        <el-table-column prop="name" :label="$t('名称')" fixed min-width="150" />
        <el-table-column prop="userNum" :label="$t('创建者编号')" fixed min-width="150" />
        <el-table-column prop="username" :label="$t('创建者名称')" fixed min-width="150" />
        <el-table-column v-for="(item, index) in tableHeader" :key="index" :label="$t(item)" width="180">
          <template v-slot="{row}">
            {{row[item]}}
          </template>
        </el-table-column>
        <el-table-column prop="createTimeStr" :label="$t('创建时间')" width="160"/>
        <el-table-column fixed="right" :label="$t('操作')" width="100">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link type="primary" :underline="false" @click="handleAddEl(row)">{{$t('查看更多')}}</el-link>
            </div>
          </template>
        </el-table-column>
      </table-list>
    </template>

  </ankh-list>
</template>

<script>
import TableList from "@/components/table-list/TableList";
import {request} from "@/config/request";
import AnkhList from "@/components/list/AnkhList.vue";
export default {
  name: "UserFoodList",
  components: {AnkhList, TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      // 动态表头
      tableHeader: [],
    }
  },
  methods: {
    // 添加元素
    handleAddEl(row) {
      this.$router.push({
        path: "/food/addEl",
        query: {
          code: row.code,
        }
      })
    },

    async handleSearch(params, setTotal) {
      try {
        let res = await request(this.$api.foodSort.listUser, params);
        const headers = new Set();
        const tableData = res.foodSorts.map(item => {
          item.createTimeStr = this.$moment(item.createTime).format('YYYY-MM-DD HH:mm:ss');
          // 设置 动态元素表头并格式化数据
          item.elementMapList.forEach(m => {
            for (const key in m) {
              item[key] = m[key];
              headers.add(key);
            }
          })
          return {
            ...item,
          };
        });

        this.tableHeader = [...headers];
        setTimeout(() => {
          this.tableData = tableData;
          setTotal(res.pager?.itemCount);
           const tableDom = this.$refs.list.getDom();
           tableDom.doLayout();
        }, 50)
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

.cover-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

/deep/ .el-dialog {
  width: 550px;
  border-radius: 10px;
}


</style>
